<template>
    <div>
        <h2 class="ml-2 mt-4">Hey DJ!</h2>
        <p class="ml-2 mt-2">It's easy to get started - just follow 2 steps</p>
        <b-card title="Step 1 - Choose your choons!" :img-src="require('../../assets/9.jpg')" img-alt="Image" img-top tag="article"
                class="ml-2 mr-2">
            <p class="card-text">
                Select three tunes from either our compiled playlists or via searching for song or artist. So what are you waiting for click ‘Let’s Do This’.
            </p>
            <b-button to="/tracks" variant="default" href="#">Let’s Do This</b-button>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: "LandingView"
    }
</script>

<style scoped>

</style>
